import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './statistics_index.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';

export class StatisticsIndexController {
  /*@ngInject*/
  constructor(SaConfigService) {
    this.saList = [];
    this.SaConfigService = SaConfigService;
  }

  $onInit() {
    this.SaConfigService.api.index(res => {
      this.saList = res;
    });
  }
}

export default angular.module('leptonApp.statisticsIndex', [uiRouter, SaConfigService])
  .config(routing)
  .component('statisticsIndex', {
    template: require('./statistics_index.html'),
    controller: StatisticsIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/index/statistics_index.component.js